// 接口 - 监控报表
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 日 - 数据转化报表 - 列表
export function getDailyBaseList(params){
  return post(`${baseApi}/dailyReport/baseReport`, params);
}

// 日 - 人保魔方链路转化报表 - 列表
export function getDailyRbList(params){
  return post(`${baseApi}/dailyReport/rbReport`, params);
}



// 点拨报表 - 转化数据 - 列表
export const getDailyHnzjList = (params) => post(`${baseApi}/dailyReport/hnzjReport`, params);
// 点拨报表 - 转化数据 - 点拨数据类型转化报表列表
export const getDailyHnzjBatchList = (params) => post(`${baseApi}/dailyReport/hnzjBatchReport`, params);
// 点拨坐席数据 - 筛选选项
export const getDbSeatOptions = (params) => get(`${baseApi}/ffx/hnzj/month-performance/detail/options`, params);
// 点拨坐席数据 - 汇总数据
export const getDbSeatSummary = (params) => post(`${baseApi}/ffx/hnzj/month-performance/detail/summary/list`, params);
// 点拨坐席数据 - 当月明细
export const getDbSeatCurrentMonthDetail = (params) => post(`${baseApi}/ffx/hnzj/month-performance/detail/list`, params);
// 点拨坐席数据 - 前月更新明细
export const getDbSeatPreviousMonthDetail = (params) => post(`${baseApi}/ffx/hnzj/month-performance/detail/list`, params);
// 点拨坐席数据 - 数据导出
export const exportDbSeatData = (params) => post(`${baseApi}/ffx/hnzj/month-performance/detail/export`, params, {responseType: "blob"});



// 日 - 均分坐席人效报表 - 列表
export function getDailyJfList(params){
  return post(`${baseApi}/dailyReport/seatReport`, params);
}
// 日 - 均分坐席人效报表 - 筛选列表
export function getDailyJfOptions(params){
  return get(`${baseApi}/dailyReport/getSelectList`, params);
}
// 日 - 均分坐席人效报表 - 数据导出
export const dailyJfExport = (params) => {
  params.isDownload = 1;
  return post(baseApi + "/dailyReport/seatReport", params, {
    responseType: "blob",
  });
}





// 0.2意外赠险转均分报表 - 列表
export function getDailyZxReport(params){
  return post(`${baseApi}/dailyReport/zxReport`, params);
}


// 日 - 企微运营报表 - 列表
export function getDailyQywxReport(params){
  return post(`${baseApi}/dailyReport/qywxReport`, params);
}

// 慢病险素材产出报表
export const getRxaMaterialReport = (params) => post(`${baseApi}/materialReport/list`, params);
export const getRxaEditorReport = (params) => post(`${baseApi}/materialReport/editingList`, params);
export const getRxaWriterReport = (params) => post(`${baseApi}/materialReport/directorList`, params);
export const getRxaMaterialReportOptions = (params) => get(`${baseApi}/materialReport/userMappingList`, params);
export const rxaMaterialReportExport = (params) => post(`${baseApi}/materialReport/list`, {...params, download: '1'}, {responseType: 'blob'});
export const rxaEditorReportExport = (params) => post(`${baseApi}/materialReport/editingList`, {...params, download: '1'}, {responseType: 'blob'});
export const rxaWriterReportExport = (params) => post(`${baseApi}/materialReport/directorList`, {...params, download: '1'}, {responseType: 'blob'});

// excel上传数据
export const rxaMaterialReportUpload = (params) => {
    const data = new FormData();
    Object.keys(params).forEach((item) => {
        data.append(item, params[item]);
    });
    return post(baseApi + "/materialReport/uploadEditing", data, {
        headers: {"Content-Type": "multipart/form-data",},
        noValid: true,
    });
}


// 均分销售转化效率追踪 - 列表
export function getJssList(params){
  return post(`${baseApi}/average/agent/export`, params);
}
// 均分销售转化效率追踪 - 数据导出
export const jssExport = (params) => {
  params.isDownload = 1;
  return post(baseApi + "/average/agent/export", params, {
    responseType: "blob",
  });
}
// 均分销售转化效率追踪 - 选项列表
export function getJssOptions(params){
  return get(`${baseApi}/average/agent/arg`, params);
}
// 均分销售转化效率追踪 - 概览数据
export function getJssOverview(params){
  return get(`${baseApi}/average/agent/month/export`, params);
}
// 均分销售转化效率追踪 - 详情 - 核心指标
export function getDetailCoreStats(params){
  return post(`${baseApi}/average/agent/tag/export`, params);
}
// 均分销售转化效率追踪 - 详情 - 核心图表
export function getDetailCoreCharts(params){
  return post(`${baseApi}/average/agent/table/export`, params);
}
// 均分销售转化效率追踪 - 详情 - 图表
export function getDetailCharts(params){
  return post(`${baseApi}/average/agent/img/export`, params);
}



// 催缴报表 - 列表
export function getUrgePayList(params){
  return post(`${baseApi}/renewal_report/query`, params);
}
// 催缴报表 - 职场选项列表
export function getUrgePayWorkplaceOptions(params){
  return get(`${baseApi}/renewal_report/listOrg`, params);
}



// AI报表 - 机构选项列表
export const getAiOrgOptions = (params) => get(`${baseApi}/aiReports/getOrgList`, params);
// AI报表 - 线路选项列表
export const getAiLineOptions = (params) => get(`${baseApi}/aiReports/getLineCompany`, params);
// AI报表 - 剧本选项列表
export const getAiLinkScriptNodeOptions = (params) => get(`${apiPrefix.aiApi}/test/queryScriptList`, params);

// AI线路 - 列表
export const getAiLineList = (params) => post(`${baseApi}/aiReports/aiLineReports`, params);
// AI线路 - 数据导出
export const aiLineExport = (params) => {
    return post(`${baseApi}/aiReports/aiLineReportsExport`, params, {
        responseType: "blob",
    });
}

// AI转化 预拨测- 列表
export const getAiPreCallReport = (params) => post(`${baseApi}/aiReports/aiPreCallReport`, params);
// AI转化 AI转人 列表
export const getAiTransferReport = (params) => post(`${baseApi}/aiReports/aiTransferReport`, params);
// AI转化 - 数据导出
export const aiConversionReportsExport = (params) => {
    return post(`${baseApi}/aiReports/aiPreCallReport`, params, {
        responseType: "blob",
    });
}
// AI转人 - 数据导出
export const aiTransferReportExport = (params) => {
    return post(`${baseApi}/aiReports/aiTransferReport`, params, {
        responseType: "blob",
    });
}
// 线路统计 - 列表
export const getAiLineCollectList = (params) => post(`${baseApi}/aiReports/lineSummary`, params);
// 线路统计 - 数据导出
export const aiLineCollectExport = (params) => {
    return post(`${baseApi}/aiReports/lineSummaryExport`, params, {
        responseType: "blob",
    });
}

// 企微链路-AI - 列表
export const getAiQwLinkList = (params) => post(`${baseApi}/aiReports/qwLinkReport`, params);
// 企微链路-职场 - 列表
export const getAiQwLinkJobMarketList = (params) => post(`${baseApi}/aiReports/queryQwLinkWorkplaceReport`, params);
// 企微链路-职场 - 导出
export const aiQwLinkJobMarketExport = (params) => post(`${baseApi}/aiReports/queryQwLinkWorkplaceExport`, params, {responseType: "blob"});


// 对话间隔时长监控 - 整体统计
export const getDialogueIntervalTimeWholeStats = (params) => get(`${baseApi}/aiReports/dialogueAllDayMonitor`, params);
// 对话间隔时长监控 - 整体单柱详情
export const getDialogueIntervalTimeWholeBarDetail = (params) => get(`${baseApi}/aiReports/dialogueAllDayMonitorTop`, params);
// 对话间隔时长监控 - 实时统计
export const getDialogueIntervalTimeActualStats = (params) => get(`${baseApi}/aiReports/dialogueHourMonitor`, params);



// 坐席均分 - 列表
export const getSeatJfList = (params) => post(`${baseApi}/avgSeatGroup/query`, params);
// 坐席均分 - 坐席选项列表
export const getSeatOptions = (params) => get(`${baseApi}/avgSeatGroup/querySeat`, params);


// 魔方转均分AI - 列表
export const getMfJfList = (params) => post(`${baseApi}/mfToAvgSeatDataReport/query`, params);
// 魔方转均分AI - 导出
export const mfJfExport = (params) => post(`${baseApi}/mfToAvgSeatDataReport/download`, params, {responseType: "blob"});
// 魔方转均分AI - 坐席选项列表
export const getMfJfSeatOptions = (params) => get(`${baseApi}/mfToAvgSeatDataReport/querySeat`, params);

